export enum DisplayMode {
  mobile = 'mobile',
  small = 'small',
  medium = 'medium',
  big = 'big',
}
